export enum PartnerTypeEnum {
  PARTNER = "partner",
  CONSULTANT = "consultant",
  REPRESENTATIVE = "representative",
  COUNTER = "counter",
  UNIT = "unit"
}

export enum PartnerTypeLabel {
  "partner" = "Parceiro",
  "consultant" = "Consultor",
  "representative" = "Representante",
  "counter" = "Contador",
  "unit" = "Unidade"
}